angular.module('bribac.components.scheduleEditor', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.services.moodQuestionEditorModal',
  'bribac.components.moodQuestion'
])

  .component('scheduleEditor', {
    templateUrl: 'schedule-editor-component.html',
    controller: 'ScheduleEditorComponentCtrl',
    bindings: {
      schedule: '<',
      // If `templateOption` is true the "Save a template copy" checkbox will be
      // shown.
      templateOption: '<',
      // If `saveToApi` is true the schedule will be PUT/POSTed to the API when
      // saving, if it's false the schedule will be passed directly to the
      // success callback instead.
      saveToApi: '<',
      // If `mutateSchedule` is true the schedule from the bindings will be used
      // in the form ng-model's, so it will be mutated, if it's false a copy of
      // the schedule will be used instead so the original is never mutated.
      mutateSchedule: '<',
      successCallback: '<',
      formChangedCallback: '<?',
      cancelCallback: '<',
      organizationCanBeSpecified: '<'
    }
  })

  .controller('ScheduleEditorComponentCtrl', function(
    $scope,
    $filter,
    KINDS,
    api,
    errorUtils,
    moodQuestionEditorModal,
    permissions,
    $translate
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions

    $ctrl.weekdays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
    $ctrl.times = getTimes($filter, 15)

    $ctrl.toggleValue = function(arrayName, value) {
      var array = $ctrl.editableSchedule[arrayName]
      if (array.indexOf(value) > -1) {
        $ctrl.editableSchedule[arrayName] = array.filter(function(item) {
          return item !== value
        })
      } else {
        array.push(value)
      }
      $ctrl.formChanged()
    }

    $ctrl.isActive = function(arrayName, value) {
      return $ctrl.editableSchedule[arrayName].indexOf(value) > -1
    }

    $ctrl.addSetTime = function() {
      $ctrl.editableSchedule.fixedTimes.push('')
    }

    $ctrl.removeSetTime = function(index) {
      $ctrl.editableSchedule.fixedTimes.splice(index, 1)
    }

    $ctrl.isRandomTestsPerDayZero = function() {
      return $ctrl.editableSchedule.maxRandomTestsPerDay === 0 && $ctrl.form.maxRandomTestsPerDay.$touched;
    };

    function isRandomTimeBlank() {
      var s = $ctrl.editableSchedule
      return !s.maxRandomTestsPerDay &&
        !s.earliestRandom &&
        !s.latestRandom
    }

    $ctrl.isRandomTestsPerDayMoreThanZero = function() {
      return $ctrl.editableSchedule.maxRandomTestsPerDay > 0
    }

    $ctrl.isRandomTimeRequired = function() {
      var hasFixedTime = $ctrl.editableSchedule.fixedTimes.some(function(time) {
        return !!time
      })

      // Random time is required when...
      // * No Fixed time has been set
      // * One Random time form field has a value
      return !hasFixedTime || !isRandomTimeBlank()
    }

    $ctrl.isSetTimeRequired = function() {
      return isRandomTimeBlank()
    }

    function resetForm() {
      if ($ctrl.form) {
        $ctrl.form.$setUntouched()
        $ctrl.form.$setPristine()
      }
    }

    function submitSuccess(request) {
      $ctrl.form._submitSuccess = 'Saved ' + request.data.name
      resetForm()
      $ctrl.successCallback(request.data)
    }

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid || !$ctrl.editableSchedule.weekdays.length) {
        $form.$invalid = true
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitSuccess = ''
      $form._submitError = ''

      if ($ctrl.saveToApi) {
        $form._submitting = true

        var copy = angular.copy($ctrl.editableSchedule)
        copy.fixedTimes = copy.fixedTimes.filter(function(time) { return !(!time.time || !time.time.trim() || time.time === 'null') })

        api[$ctrl.editableSchedule.id ? 'put' : 'post'](KINDS.SCHEDULE, copy)
          .finally(function() { $form._submitting = false })
          .then(submitSuccess, function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          })
      } else {
        submitSuccess({data: copy})
      }
    }

    $ctrl.$onChanges = function(changes) {
      if (changes.schedule) {
        // Reset state since the schedule instance we're editing has changed.
        resetForm()
        $ctrl.editableSchedule = $ctrl.mutateSchedule ? $ctrl.schedule : angular.copy($ctrl.schedule)
        // Make sure there is at least one empty fixed time that can be shown
        // in the UI. The server will ignore empty times.
        if (!$ctrl.editableSchedule.fixedTimes.length) {
          $ctrl.editableSchedule.fixedTimes.push('')
        }
      }
    }

    $ctrl.invalidateAndTouchFormItem = function(formItem) {
      formItem.$invalid = true
      formItem.$touched = true
    }

    $ctrl.areNoDaysSelected = function () {
      return !$ctrl.editableSchedule.weekdays.length &&
        (($ctrl.form['fixedTimes0'] && $ctrl.form['fixedTimes0'].$touched) || $ctrl.form.maxRandomTestsPerDay.$touched);
    };

    $ctrl.isLatestRandomAfterEarliest = function () {
      return isEarliestAfterLatest($ctrl.editableSchedule.latestRandom, $ctrl.editableSchedule.earliestRandom);
    };

    $ctrl.fixedTimeSet = function() {
      return $ctrl.editableSchedule.fixedTimes[0] !== ''
    }

    $ctrl.randomBoundariesDefined = function() {
      return $ctrl.editableSchedule.latestRandom !== undefined && $ctrl.editableSchedule.earliestRandom !== undefined
    }

    $ctrl.pristineAndUntouchedForm = function(form) {
      form.$setUntouched()
      form.$setPristine()
    }

    $ctrl.setFormItemValidity = function(formItem, message, validity) {
      formItem.$setValidity(message, validity);
      if (!validity) {
        formItem.$setTouched(true);
      }
    }

    $ctrl.startOfRandomIntervalsDefined = function() {
      return $ctrl.editableSchedule.latestRandom[0] !== '' && $ctrl.editableSchedule.earliestRandom[0] !== ''
    }

    $scope.$on('submitError', function () {
      $ctrl.form['fixedTimes0'].$setTouched();
      if ($ctrl.form['name']) {
        $ctrl.form['name'].$setTouched();
      }
    });

    $ctrl.formChanged = function () {
          $ctrl.form._submitError = '';

          var formItemSet = true;
          var maxRandomTestsPerDay = $ctrl.editableSchedule.maxRandomTestsPerDay;
          if (maxRandomTestsPerDay) {
              if ($ctrl.isRandomTestsPerDayMoreThanZero()) {
                  if (!$ctrl.editableSchedule.earliestRandom && !$ctrl.editableSchedule.latestRandom) {
                      $ctrl.invalidateAndTouchFormItem($ctrl.form.earliestRandom);
                      $ctrl.invalidateAndTouchFormItem($ctrl.form.latestRandom)
                  } else if (!$ctrl.editableSchedule.earliestRandom) {
                      $ctrl.invalidateAndTouchFormItem($ctrl.form.earliestRandom)
                  } else if (!$ctrl.editableSchedule.latestRandom) {
                      $ctrl.invalidateAndTouchFormItem($ctrl.form.latestRandom)
                  }
                  if (!$ctrl.editableSchedule.earliestRandom || !$ctrl.editableSchedule.latestRandom)
                      formItemSet = false;
              }
          } else {
              if ($ctrl.form.earliestRandom.$invalid && $ctrl.form.latestRandom.$invalid) {
                  $ctrl.pristineAndUntouchedForm($ctrl.form.earliestRandom);
                  $ctrl.pristineAndUntouchedForm($ctrl.form.latestRandom)
              } else if ($ctrl.form.earliestRandom.$invalid) {
                  $ctrl.pristineAndUntouchedForm($ctrl.form.earliestRandom)
              } else if ($ctrl.form.latestRandom.$invalid) {
                  $ctrl.pristineAndUntouchedForm($ctrl.form.latestRandom)
              }
          }

      $ctrl.setFormItemValidity($ctrl.form.earliestRandom, 'errors.earliestAfterLatest', !$ctrl.isLatestRandomAfterEarliest());
      $ctrl.setFormItemValidity($ctrl.form.latestRandom, 'errors.earliestAfterLatest', !$ctrl.isLatestRandomAfterEarliest());
      if (!$ctrl.isLatestRandomAfterEarliest() && formItemSet) {
        $ctrl.pristineAndUntouchedForm($ctrl.form.earliestRandom);
        $ctrl.pristineAndUntouchedForm($ctrl.form.latestRandom);
      }
      if ($ctrl.formChangedCallback) {
        $ctrl.formChangedCallback();
      }
    };

    $ctrl.showScheduleTestMoodQuestionModal = function(selectedId, index) {
      moodQuestionEditorModal(selectedId, function saveSuccess(message) {
        $ctrl.editableSchedule.fixedTimes[index].question = message
      })
    }

    $ctrl.showRandomTestMoodQuestionModal = function(selectedId, index) {
      moodQuestionEditorModal(selectedId, function saveSuccess(message) {
        if (index != -1) {
          $ctrl.editableSchedule.moodQuestion[index] = message
        } else {
          if($ctrl.editableSchedule.moodQuestion === undefined || $ctrl.editableSchedule.moodQuestion.indexOf(message) == -1){
            $ctrl.editableSchedule.moodQuestion.push(message)
          }
        }
      })
    }

    $ctrl.isMoodQuestionSelected = function(){
      return $ctrl.editableSchedule.moodQuestion && $ctrl.editableSchedule.moodQuestion.length > 0
    }

    $ctrl.removeMoodQuestion = function($index){
      $ctrl.editableSchedule.moodQuestion.splice($index, 1)
    }

    $ctrl.removeFixedTimeMoodQuestion = function($index){
      delete $ctrl.editableSchedule.fixedTimes[$index].question
    }

  });

function bothStringsContainCharacter(earliestRandom, latestRandom, char) {
  return earliestRandom.indexOf(char) !== -1 && latestRandom.indexOf(char) !== -1;
}

function isEarliestAfterLatest(latestRandom, earliestRandom) {
  if (latestRandom !== undefined && earliestRandom !== undefined) {
    var colon = ':';
    if (bothStringsContainCharacter(earliestRandom, latestRandom, colon)) {
      var reg = new RegExp(colon);
      var earliestNumber = parseInt(earliestRandom.replace(reg, ''), 10);
      var latestNumber = parseInt(latestRandom.replace(reg, ''), 10);
      if (latestNumber < earliestNumber) {
        return true;
      }
    }
  }
  return false;
}

function getTimes(filter, intervalInMinutes) {
  // array of particular times different by interval
  var times = new Array();
  // time object to be increased by interval
  var time = new Date(0);
  // iterate until we get to 24 hours
  var i;
  times.push('');
  for (i = 0; i < (24 * 60);) {
    times.push(filter('date')(time,'HH:mm', '+0000'));
    time = new Date(time.getTime() + (intervalInMinutes * 60 * 1000));
    i = i + intervalInMinutes;
  }
  return times;
}